var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.297V4C16.75 1.582 15.418 0.25 13 0.25H3C1.483 0.25 0.25 1.483 0.25 3V16C0.25 18.418 1.582 19.75 4 19.75H16C18.418 19.75 19.75 18.418 19.75 16V8C19.75 5.845 18.692 4.553 16.75 4.297ZM18.25 13.75H14.5C13.535 13.75 12.75 12.965 12.75 12C12.75 11.035 13.535 10.25 14.5 10.25H18.25V13.75ZM3 1.75H13C14.577 1.75 15.25 2.423 15.25 4V4.25H3C2.311 4.25 1.75 3.689 1.75 3C1.75 2.311 2.311 1.75 3 1.75ZM16 18.25H4C2.423 18.25 1.75 17.577 1.75 16V5.44897C2.125 5.64097 2.55 5.75 3 5.75H16C17.577 5.75 18.25 6.423 18.25 8V8.75H14.5C12.708 8.75 11.25 10.208 11.25 12C11.25 13.792 12.708 15.25 14.5 15.25H18.25V16C18.25 17.577 17.577 18.25 16 18.25ZM15.01 11H15.02C15.573 11 16.02 11.448 16.02 12C16.02 12.552 15.573 13 15.02 13C14.468 13 14.015 12.552 14.015 12C14.015 11.448 14.458 11 15.01 11Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.69d2329d4f7c45f8e1e5e9872876d2e2.svg";